export const HEADER_STRINGS = {
	TITLE: 'EMULATION PLATFORM CLOUD',
	HELLO: 'Hello',
};

export const MENU_STRINGS = {
	DASHBOARD: 'Dashboard',
	JOB_CONFIGURATION: 'Job Configuration',
	UPLOAD_INGREDIENT: 'Upload Ingredient',
	RELEASE_PACKAGE: 'Release Package',
	FARM_REPOSITORY: 'Farm Repository',
};

export const JOB_CONFIG_STRINGS = {
	STAGE_ZERO: {
		TITLE: 'Please Select an Option',
		CREATE: 'CREATE NEW JOB',
		IMPORT: 'IMPORT',
		CREATE_PACKAGE: 'CREATE NEW PACKAGE',
	},
	PROJECT_SELECTION: {
		TITLE: 'Please Select a Project',
		LOADING: 'Loading...',
	},
	CONFIG_SETTING: {
		GRATEST_AND_LATEST: 'Greatest & Latest',
		WITHOUTֹֹֹּ_DEPENDENCIES: 'Without dependencies',
		RELEASE_NOTE: 'Release note',
		FPGA: {
			BOX_TITLE: 'FPGA',
			SELECT_TITLE: 'FPGA',
			SELECT_PLACEHOLDER: 'Please select FPGA mode',
			SELECT_KEY: 'FPGA',
		},
		ROMS: {
			BOX_TITLE: 'ROMs & FWs',
			SELECT_PLACEHOLDER_PREFIX: 'Please select',
		},
		SIMICS: {
			BOX_TITLE: 'SIMICS',
			SELECT_TITLE: 'Simics',
			SELECT_PLACEHOLDER: 'Please select simics',
			SELECT_KEY: 'SIMICS',
		},
		VPSPI: {
			BOX_TITLE: 'BIOS',
			SELECT_TITLE: 'BIOS',
			SELECT_PLACEHOLDER: 'Please select BIOS',
			SELECT_KEY: 'BIOS',
		},
		OS: {
			BOX_TITLE: 'OS',
			SELECT_TITLE: 'OS',
			SELECT_PLACEHOLDER: 'Please select OS',
			SELECT_KEY: 'OS',
		},
	},
	DATA_MAIN_KEY: 'jsonData',
	TOKEN_KEY: 'token',
	USERNAME_KEY: 'userName',
};
